// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-name-container.choice-question .mat-mdc-card {
  padding-right: 0;
}
.question-name-container.choice-question .mat-mdc-card .mat-mdc-card-content {
  width: 100%;
}
.question-name-container.choice-question .mat-mdc-card .mat-mdc-card-content .mat-form-field-outer-wrapper {
  width: 95%;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-choice-question/fi-choice-question.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAEQ;EACI,WAAA;AAAZ;AAEY;EACI,UAAA;AAAhB","sourcesContent":[".question-name-container.choice-question {\r\n    .mat-mdc-card {\r\n        padding-right: 0;\r\n\r\n        .mat-mdc-card-content {\r\n            width: 100%;\r\n\r\n            .mat-form-field-outer-wrapper {\r\n                width: 95%;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
